import axios from "axios";
import { memoizer } from "@/utils/memoizer";

export function getPractitioner(idPractitioner) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/practitioner/identifier/${idPractitioner}`)
            .then((response) => {
                const data = response.data.data;
                if (data && data.practitioner) {
                    resolve(data.practitioner);
                } else {
                    resolve(data);
                }
            })
            .catch((error) => reject(error));
    });
}

export function getAllPractitioners() {
    return new Promise((resolve, reject) => {
        axios
            .get("/api/practitioner")
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => reject(error));
    });
}

export const memoizedGetPractitioner = memoizer(getPractitioner);

export function postPractitioner(practitioner_data) {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/practitioner", practitioner_data)
            .then((data) => resolve(data))
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
}

export function putPractitioner(practitioner_data, idPractitioner) {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/practitioner/${idPractitioner}`, practitioner_data)
            .then((data) => resolve(data))
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
}

export function getDoctorInfoByCedula(cedula) {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/practitioner/doctor-info/${cedula}`)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
}
